<template>
  <Flex
    direction="column"
    :gap="1"
  >
    <Actions
      :date="date"
      :items="entries"
      @setDate="date = $event"
    />
    <BaseCard>
      <EntriesList
        :items="entries"
        :date="date"
        :loading="isLoading"
      />
    </BaseCard>
  </Flex>
</template>

<script
  lang="ts"
  setup
>
import { useRouteDate } from '@/helpers/routing';
import Actions from '@/modules/_shared/waiting-list/Actions.vue';
import EntriesList from '@/modules/_shared/waiting-list/EntriesList.vue';
import { useEntriesQuery } from '@/modules/_shared/waiting-list/helpers';

const { date } = useRouteDate({
  updateRouteQuery: true,
});

const { entries, isLoading } = useEntriesQuery(date);
</script>
